import "./new-util-transport-location.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilTransportLocation from "../form-util-transport-location/form-util-transport-location";
import { useNewUtilTransportLocation } from "./new-util-transport-location.hook";

export function NewUtilTransportLocation() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewUtilTransportLocation();

  return (
    <div id="NewUtilTransportLocation" className="util-transport-location">
      <HeaderContent
        title={<h1>New Transport Location</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormUtilTransportLocation />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewUtilTransportLocation;
